(function(){
  'use strict';
  function initQtyStepper(root){
    var input = root.querySelector('input[name="quantity"]');
    if(!input) return;
    root.querySelectorAll('[data-qty-step]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var step = parseInt(btn.getAttribute('data-qty-step'), 10);
        var next = Math.max(1, (parseInt(input.value,10) || 1) + step);
        input.value = next;
        input.dispatchEvent(new Event('change', {bubbles:true}));
      });
    });
  }
  function initCopyCode(root){
    var btn = root.querySelector('[data-copy-code]');
    if(!btn) return;
    btn.addEventListener('click', function(){
      var code = btn.getAttribute('data-copy-code');
      if(navigator.clipboard){
        navigator.clipboard.writeText(code).then(function(){
          var original = btn.textContent;
          btn.textContent = 'Copied';
          setTimeout(function(){ btn.textContent = original; }, 1800);
        });
      }
    });
  }
  document.querySelectorAll('[data-product-form]').forEach(initQtyStepper);
  document.querySelectorAll('[data-coupon]').forEach(initCopyCode);
})();
